import { adminHttpClient } from "../../../commons/adminHttpClinet";
import { OrderType, UpdateMarketplaceOrderModel } from "../../../models/dashboard/marketplace/marketplaceCategoryModel";

const updateOrder = (type:OrderType, model: Array<UpdateMarketplaceOrderModel>) : Promise<any> => {
    return adminHttpClient.put(`/api/Admin/AdminMarketplace/order-item?type=${type}`, model);
};

export  default updateOrder;